import Chart from 'chart.js';
export default {
  name: 'line-chart',

  props: ['plots', 'labels', 'yStepsSize', 'yMax'],

  data: function () {
    return {
      ctx: null,
      chart: null,
      yTicksConfig: {
        beginAtZero:true,
        fontSize: 10
      }
    }
  },

  mounted:function() {
    if(this.yStepsSize) {
      this.yTicksConfig.stepSize = this.yStepsSize;
    }

    if(this.yMax) {
      this.yTicksConfig.max = this.yMax;
    }

    if(this.plots && this.labels && !this.chart) {
      this.init();
    }
  },

  beforeDestroy: function() {

  },

  methods: {
    init: function() {
      this.ctx = this.$refs.canvas;
      // defaults
      Chart.defaults.global.defaultFontColor = '#48c5db';

      // Options for the chart
      var options = {
          // Make chart flexible
          maintainAspectRatio:false,
          // Straight lines
          elements: {
            line: {
              tension: 0, // disables bezier curves
            }
          },
          // Hide legend
          legend: {
            display: false
          },
          tooltips: {
            backgroundColor: '#fff',
            titleFontFamily: "'PlutoSansRegular', 'Helvetica', 'Arial', sans-serif",
            titleFontSize: 12,
            titleFontStyle: 'bold',
            titleFontColor: '#a5a5a5',
            titleSpacing: 2,
            titleMarginBottom: 6,
            bodyFontColor: '#a5a5a5',
            bodyFontFamily: "'PlutoSansRegularCond', 'Helvetica', 'Arial', sans-serif",
            borderColor: '#ebebeb',
            borderWidth: 1,
            xPadding: 20,
            yPadding: 10,
            displayColors: true,
            caretPadding: 4,
            caretSize: 8
          },
          // Axes and grid lines
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
              },
              ticks: {
                beginAtZero:true,
                min: 0,
                fontSize: 10
              }
            }],
            yAxes: [{
              ticks: this.yTicksConfig
            }]
          }
        }

      // Data object we will style
      var styledData = {
          'labels': this.labels,
          'datasets': [{
            'data': this.plots,
          }]
        }

      // Set the color of each dataset's lines and points
      for (var i = 0; i < styledData.datasets.length; i++)
      {
        styledData.datasets[i].borderColor ='#48c5db',
        styledData.datasets[i].borderWidth = 1.5,
        styledData.datasets[i].backgroundColor = 'transparent',
        styledData.datasets[i].pointBackgroundColor = "#48c5db",
        styledData.datasets[i].pointRadius = 3,
        styledData.datasets[i].pointHoverRadius = 3
      }


      this.chart = new Chart(this.ctx, { 'type': 'line', 'data': styledData, 'options': options});
    }
  },

  computed:{

  },

  watch: {
  	labels: function(newVal, oldVal) { // watch it
      if(this.plots && this.labels && !this.chart) {
        this.init();
      }
    },

    plots: function(newVal, oldVal) {
      if(this.plots && this.labels && !this.chart) {
        this.init();
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/LineChart/LineChart.js